function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "cashew",
  d: "M625.087,0C535.915,0,463.372,72.548,463.372,161.721a69.2,69.2,0,1,1-138.4,0C324.976,72.548,251.742,0,161.721,0,72.548,0,0,72.548,0,161.721c0,104,41.363,202.626,116.461,277.7,74.088,74.112,172.716,114.933,277.713,114.933S597.8,513.54,671.881,439.428c75.1-75.08,116.467-173.7,116.467-277.707C788.348,72.548,715.108,0,625.087,0ZM639.21,406.756c-65.361,65.385-152.386,101.394-245.036,101.394S214.5,472.141,149.132,406.75C82.761,340.4,46.2,253.378,46.2,161.721A115.649,115.649,0,0,1,161.721,46.2c64.543,0,117.051,51.822,117.051,115.517a115.4,115.4,0,1,0,230.8,0A115.644,115.644,0,0,1,625.087,46.2c64.543,0,117.057,51.822,117.057,115.517C742.144,253.378,705.587,340.4,639.21,406.756Zm0,0",
  fill: "#b4b4b4"
});

function SvgCashew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.348,
    height: 554.355,
    viewBox: "0 0 788.348 554.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashew);
export default __webpack_public_path__ + "static/media/cashew.0fc7cc98.svg";
export { ForwardRef as ReactComponent };